export default function Footer(props) {
  return (
    <div className="footer">
      <div className="wrapper">
        <nav class="footnav">
          <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#education">Education</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#experience">Experience</a></li>
              <li><a href="#contact">Contact</a></li>
          </ul>
          <p>© Neale Taylor, 2022</p>
        </nav>
      </div>
    </div>
  )
}